/**
 * Lokale App-Einstellungen (pro Gerät, localStorage): Ein-/Ausklapp-Zustände
 * der Übersichtsseite. Der Bearbeitungsmodus (Stift) ist bewusst kein Teil
 * davon – er gehört jeweils der Seite, die ihn anzeigt, und lebt nur
 * innerhalb ihres Seitenbesuchs.
 */

/* ---------- Ein-/Ausklapp-Zustände (Übersichtsseite) ---------- */

const COLLAPSE_KEY = "lernapp.collapsed.v1";

type CollapseMap = Record<string, boolean>;

function readCollapse(): CollapseMap {
  try {
    return JSON.parse(localStorage.getItem(COLLAPSE_KEY) ?? "{}") as CollapseMap;
  } catch {
    return {};
  }
}

export function isCollapsed(key: string, defaultCollapsed = false): boolean {
  const map = readCollapse();
  return key in map ? map[key] === true : defaultCollapsed;
}

export function setCollapsed(key: string, collapsed: boolean): void {
  const map = readCollapse();
  if (collapsed) map[key] = true;
  else delete map[key];
  try {
    localStorage.setItem(COLLAPSE_KEY, JSON.stringify(map));
  } catch {
    /* ignore */
  }
}

/**
 * Gegenstück für Bereiche, die standardmäßig **zu** sind (z. B. das Archiv):
 * gespeichert wird der geöffnete Zustand, unbekannt bedeutet zugeklappt.
 */
export function isOpen(key: string): boolean {
  return readCollapse()[`open:${key}`] === true;
}

export function setOpen(key: string, open: boolean): void {
  setCollapsed(`open:${key}`, open);
}
